import { type ReactNode, useEffect, useId, useRef } from 'react';

export function ProfileDialog({
  title,
  onCancel,
  onApply,
  children,
}: {
  readonly title: string;
  readonly onCancel: () => void;
  readonly onApply?: () => void;
  readonly children: ReactNode;
}): React.ReactElement {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  useEffect(() => {
    const dialog = ref.current;
    if (dialog === null) return;
    const opener = document.activeElement;
    dialog.showModal();
    return () => {
      dialog.close();
      if (opener instanceof HTMLElement && opener.isConnected) {
        opener.focus({ preventScroll: true });
      }
    };
  }, []);

  return (
    <dialog
      ref={ref}
      className="profile-dialog"
      aria-labelledby={titleId}
      onCancel={(event) => {
        event.preventDefault();
        onCancel();
      }}
    >
      <header className="profile-dialog__head">
        <h2 id={titleId}>{title}</h2>
      </header>
      {children}
      <footer className="profile-dialog__actions">
        <button type="button" onClick={onCancel}>
          {onApply ? 'Отмена' : 'Закрыть'}
        </button>
        {onApply && (
          <button type="button" className="profile-dialog__apply" onClick={onApply}>
            Применить
          </button>
        )}
      </footer>
    </dialog>
  );
}
